import { render, staticRenderFns } from "./Alterations.vue?vue&type=template&id=01caae28&"
import script from "./Alterations.vue?vue&type=script&lang=js&"
export * from "./Alterations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports